// Mapping centralisé type de notification → catégorie d'affichage.
// Aligné avec /app/backend/core/notification_categories.py.

export const CATEGORY_BY_TYPE = {
  // Pointage
  manual_clock_in_by_manager: "pointage",
  manual_clock_out_by_manager: "pointage",
  late_clock_in: "pointage",
  // Absences
  collaborateur_marked_absent: "absence",
  collaborateur_absent: "absence",
  collaborateur_absence_cancelled: "absence",
  // Planning
  shift_reminder: "planning",
  shift_planned: "planning",
  shift_assigned_replacement: "planning",
  department_agenda_created: "planning",
  // Demandes
  shift_change_request: "demandes",
  shift_change_decision: "demandes",
  leave_request: "demandes",
  leave_decision: "demandes",
  // Équipement
  equipment_assigned: "equipement",
  equipment_request: "demandes",
  equipment_request_decision: "demandes",
  equipment_return_requested: "equipement",
  equipment_return_collab_signed: "equipement",
  equipment_return_validated: "equipement",
  equipment_return_rejected_by_controller: "equipement",
  equipment_return_cancelled: "equipement",
  equipment_return_contract_end_reminder: "equipement",
  equipment_return_overdue: "equipement",
  // Documents
  document_uploaded: "document",
  payslip_missing: "document",
  // Compte
  password_reset_request: "compte",
};

export const DEFAULT_CATEGORY = "autre";

export const CATEGORIES = [
  "pointage", "absence", "planning", "demandes",
  "equipement", "document", "compte", "autre",
];

export const CATEGORY_META = {
  pointage:  { label: "Pointage",   color: "#F59E0B", bg: "bg-amber-50",    border: "border-amber-200",   text: "text-amber-800" },
  absence:   { label: "Absences",   color: "#DC2626", bg: "bg-red-50",      border: "border-red-200",     text: "text-red-800" },
  planning:  { label: "Planning",   color: "#4F46E5", bg: "bg-indigo-50",   border: "border-indigo-200",  text: "text-indigo-800" },
  demandes:  { label: "Demandes",   color: "#7C3AED", bg: "bg-violet-50",   border: "border-violet-200",  text: "text-violet-800" },
  equipement:{ label: "Équipement", color: "#0D9488", bg: "bg-teal-50",     border: "border-teal-200",    text: "text-teal-800" },
  document:  { label: "Documents",  color: "#A855F7", bg: "bg-purple-50",   border: "border-purple-200",  text: "text-purple-800" },
  compte:    { label: "Compte",     color: "#16A34A", bg: "bg-emerald-50",  border: "border-emerald-200", text: "text-emerald-800" },
  autre:     { label: "Autre",      color: "#52525B", bg: "bg-zinc-50",     border: "border-zinc-200",    text: "text-zinc-800" },
};

export function getCategory(type) {
  return CATEGORY_BY_TYPE[type] || DEFAULT_CATEGORY;
}

export function getCategoryMeta(cat) {
  return CATEGORY_META[cat] || CATEGORY_META.autre;
}
